export default "__VITE_ASSET__4gjfG7Y8__"